import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {CertificateInfo} from '../../../../../shared/models/api/eCertificatesResponsePayload';
import {ScrollViewMapProps} from '../../../../../shared/components/yaMap';
import {useHistoryTabMobileStyles} from './HistoryTabMobile.style';
import {HistoryItemCard} from '../HistoryItemCard';

interface HistoryTabProps {
  mapProps: ScrollViewMapProps;
  transactions?: CertificateInfo['transactions'];
  activeTruIds?: number[];
  setActiveTruIds: React.Dispatch<React.SetStateAction<number[] | undefined>>;
  onTruClick: (truId: number, refToScroll: React.RefObject<View>) => void;
}

export function HistoryTabMobile({mapProps, transactions, activeTruIds, setActiveTruIds, onTruClick}: HistoryTabProps) {
  const styles = useHistoryTabMobileStyles();
  // const sellers = useSelector(sellersSelector());
  // const dispatch = useDispatch();
  // const mapContainerRef = useRef<View>(null);

  // useEffect(() => {
  //   setActiveTruIds(undefined);
  //   dispatch(eCertificatesSlice.actions.setSellers([]));
  //   dispatch(eCertificatesSlice.actions.setDepartment(null));
  // }, []);

  return (
    <View style={{paddingBottom: 16}}>
      {/* <View style={styles.historyCardList}> */}
      {transactions?.map(({truName, typeName, amount, quantity, address, sellerDepartment, dateTime}, index) => (
        <TouchableOpacity key={index}>
          <View style={styles.historyCard}>
            <HistoryItemCard
              typeName={typeName}
              truName={truName}
              address={address}
              dateTime={dateTime}
              amount={amount}
              quantity={quantity}
              sellerDepartment={sellerDepartment}
            />
          </View>
        </TouchableOpacity>
      ))}

      {/* <View ref={mapContainerRef}>
          <SellersGeoMap sellers={sellers} setActiveTruIds={setActiveTruIds} mapProps={mapProps} />
        </View> */}
      {/* </View> */}
    </View>
  );
}
